import { combineReducers, applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { likeReducer } from "./like/reducer";

const root = combineReducers({
  likes: likeReducer,
});

export const store = createStore(
  root,
  composeWithDevTools(applyMiddleware(thunk))
);
